module.exports = __webpack_public_path__ + "static/media/civil-worker.3481c052.svg";